import {DateRange} from "../types/daily-feedback-reports-page.types";

export const periodSelectData = [
  {
    id: 'today',
    value: 'Сегодня'
  },
  {
    id: 'yesterday',
    value: 'Вчера'
  },
  {
    id: 'threeDays',
    value: '3 дня'
  },
  {
    id: 'sevenDays',
    value: '7 дней'
  },
  {
    id: 'currentMonth',
    value: 'Текущий месяц'
  },
  {
    id: 'previousMonth',
    value: 'Предыдущий месяц'
  },
  {
    id: 'thirtyDays',
    value: '30 дней'
  },
  {
    id: 'ninetyDays',
    value: '90 дней'
  },
  {
    id: 'year',
    value: '365 дней'
  }
]

export const defaultDateRange: DateRange = {
  dateFrom: '',
  dateTo: ''
}
